<template>
  <div class="probeFun">
    <el-image style="width: 100%;  height: 328px; background:#fff" :src="dataMsgSrc" :preview-src-list="pinkUrls" alt="图片未加载成功"></el-image>
    <div class="proBot"><span></span></div>
    <div class="nowPolice" style="text-align:center;">
    </div>
  </div>
</template>

<script>
export default {
  name:"probeFun",
  props:{
    msgDataId:{
      type:String,
      default:'',
    }
  },
  data() {
    return {
      pinkUrls:[],
      dataMsgSrc:''
    };
  },
  watch(){

  },
  created(){
    let _this = this;
    this.http.post("/webapi/writ/getimgPic", {id:_this.msgDataId}, function(sucess){
      if(sucess.code == 0){
        _this.dataMsgSrc = sucess.data.pictureUrl;
        _this.pinkUrls.push(sucess.data.pictureUrl);
      }else{
        _this.$message.error('请求失败')
      }
    });
  },
  methods: {

  },
};
</script>



// WEBPACK FOOTER //
// src/pages/baseCall/wbDialog.vue